
















import {Component, Vue} from "vue-property-decorator";
import {Button, Dialog, Toast} from "vant";
import customField from "@/components/customField/index.vue";
import {login} from "@/utils/hybirdMethods";

import {getBrowser} from "@/utils/browser";
import {goBack} from "@/utils/hybirdMethods";
import axios from "axios";

const browser = getBrowser();

@Component({
  components: {
    [Button.name]: Button,
    [customField.name]: customField
  }
})
export default class Login extends Vue {
  form = {
    content: "",
    isShow: true,
    isChange: false
  };

  created() {
    this.getAvailablerAtio();
  }


  inputChange() {
    // this.form.isShow=true;
    this.form.isChange = true;
  }

  getAvailablerAtio() {
    (this as any).$apis
        .getAvailablerAtioAPI()
        .then(res => {
          
          this.form.content = (Number(res.data.data.availableRatio) * 100) + "";
        })
        .catch(e => {
          
        });
  }

  setAvailablerAtio() {
    var count = Number(this.form.content);
    if (count > 100 || count <= 0) {
      Toast("比例应该在 [1-100] 内");
      return;
    }

    var availableRatioStr = Number(this.form.content) / 100 + "";

    const params = {
      availableRatio: availableRatioStr,
    };
    
    if ((this as any).form.isChange) {
      
      (this as any).$apis
          .setAvailablerAtioAPI(params)
          .then(res => {
            Toast("设置成功");
            // this.form.isShow=false;
            this.$router.push({path: "/h5-page-transaction"})
          })
          .catch(e => {
            
          });
    } else {
      
      this.$router.push({path: "/h5-page-transaction"})
    }

  }

}
